// External dependencies.
import $ from "jquery";
import { __ } from "@wordpress/i18n";

( function () {
    const { theme_file_uri, shipping_costs_faq_url } = window.app;

    const template = `
        <div class="popover border-0 shadow ts-packing-supplies-popover" role="tooltip" style="font-size: 1rem;">
            <div class="position-relative">
                <img
                    src="${theme_file_uri}/assets/images/packing_tiosimon.webp" 
                    class="ts-packing-supplies-popover-image" 
                    width="200" 
                    height="300"
                    loading="lazy"
                >
            </div>
            <div class="popover-body"></div>
        </div>
    `;

    const content = `
        <h4 class="text-uppercase text-primary mb-3">${__( 'Paquete Refrigerado', 'tio-simon-foods' )}</h4>
        <p class="font-mali text-primary">${__( 'Nuestros productos son empacados con hielo seco para mantener la temperatura de los productos durante el viaje', 'tio-simon-foods' )}</p>
        <a href="${shipping_costs_faq_url}" class="font-mali font-weight-bold ts-packing-supplies-popover-anchor">${__( 'Conoce más', 'tio-simon-foods' )}</a>
    `;

    $( '#ts-packing-supplies-popover-button' ).popover( {
        container: 'body',
        content,
        html: true,
        placement: 'left',
        template
    } );

    if ( window.matchMedia( "(min-width: 992px)" ).matches ) {
        $( '#ts-packing-supplies-popover-button' ).popover( 'show' );
    }
} )();
